import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalWindow from '../../common/Modal';
import RadioGroup from '../../common/RadioGroup';
import Radio from '../../common/Radio';
import styles from './BulkEditInventoryBuffersModal.module.scss';
import Button from '../../common/Button';
import { postVariantBuffers } from '../../../store/actions/variant-bulk-edit';
import { setBulkVariantEdit } from '../../../store/actions/supplierInventory';
import SimpleInput from '../../common/SimpleInput';
import { useMixpanel } from 'react-mixpanel-browser';
import { CHANGE_BUFFER_BY_SKU } from '../../../constants/mixpanel';
import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';

const actionTypes = {
  EDIT: 'edit-buffer',
  RESET: 'reset-buffer',
};

function BulkEditInventoryModal({ onClose, open = false }) {
  const { selectedVariants, bulkEdit } = useSelector((state) => state.supplierInventory);
  const supplierName = useSelector((state) => state.role?.supplier?.name);
  const mixpanel = useMixpanel();

  const dispatch = useDispatch();
  const [action, setAction] = useState(actionTypes.EDIT);
  const [bufferQuantity, setBufferQuantity] = useState(0);
  useEffect(() => {
    if (bulkEdit.success) {
      onClose();
      dispatch(setBulkVariantEdit());
    }
  }, [bulkEdit, dispatch, onClose]);

  const confirmEdit = () => {
    const bufferValue = action === actionTypes.EDIT ? bufferQuantity : null;
    reportBusinessActionToMixpanel(mixpanel, CHANGE_BUFFER_BY_SKU, {
      supplierName,
      action: action,
      value: bufferValue,
      skuAmount: selectedVariants.objectIds.length,
    });
    dispatch(postVariantBuffers(bufferValue, selectedVariants.objectIds));
  };

  const handleBufferChange = (e) => {
    const inputValue = e.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
    setBufferQuantity(Math.min(parseInt(sanitizedValue || 0), 500));
  };

  return (
    <ModalWindow open={open} onClose={onClose} center>
      <h3>Bulk Editing Buffers</h3>
      <p>Adjust the buffer value to modify the inventory levels sent to your sales channels</p>
      <div className={styles.content}>
        <RadioGroup name="edit options" onChange={(value) => setAction(value)} column selectedvalue={action}>
          <div className={styles.bufferWrapper}>
            <Radio
              id="edit-buffer"
              value={actionTypes.EDIT}
              label={`Edit buffer quantity for ${selectedVariants.objectIds.length} SKU(s)`}
            />
            <SimpleInput
              className={styles.bufferInput}
              value={bufferQuantity}
              onChange={handleBufferChange}
              type="text"
              name="buffer"
            />
          </div>
          <span>The buffer value set here will override the sales channel defaults for the selected SKUs</span>
          <div className={styles.bufferWrapper}>
            <Radio id="reset-buffer" value={actionTypes.RESET} label={'Reset buffers to sales channel defaults'} />
          </div>
        </RadioGroup>
      </div>
      <div className={styles.actions}>
        <Button text="Cancel" onClick={onClose} color="white" />
        <Button disabled={bulkEdit.isLoading} text="Confirm changes" onClick={confirmEdit} />
      </div>
    </ModalWindow>
  );
}

export default BulkEditInventoryModal;

BulkEditInventoryModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};
